import * as z from "zod";
import { mutator } from "./mutator";

export const recordNavigationClick = mutator({
  schema: z.object({
    surface: z.string().max(32),
    destination: z.string().max(64),
  }),
  resolve: {},
  permissions: { none: "records that the caller clicked their own screen" },
  description:
    "Triggered when a user clicks a navigation item in the sidebar, top bar, or profile menu.",
  interactionType: "view",
  fn: async () => {},
});
